module.exports = __webpack_public_path__ + "img/no-results.1bea49ef.webp";